import axios from "@/components/api/axios";

const list = request => {
    return axios.post(
        '/ps/list',
        request).then(response => response.data)
}

const get = request => {
    return axios.post(
        '/ps/get',
        request).then(response => response.data)
}

const add = request => {
    return axios.post(
        '/ps',
        request).then(response => response.data)
}

const upd = request => {
    return axios.put(
        '/ps',
        request).then(response => response.data)
}

export default {
    get,
    list,
    add,
    upd
}